import React, { useMemo } from "react";

import Link from "next/link";
import { useSearchParams } from "next/navigation";

import styles from "./PaginationSection.module.scss";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";


const PaginationSection = ({ pageLength = 1, currentPageNumber, slug }) => {
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams.toString());

  const pageBufferSize =
    currentPageNumber - 5 > 0 && pageLength >= currentPageNumber ? currentPageNumber - 5 : 0;

  const appendParams = (url: string) =>  params.toString().length ? url +"?" + params.toString() : url;

  const isButtonVisible = pageLength > 5;

  const pageNumbers = useMemo(() => {
    const pages = [];
    for (let i = 0; i < pageLength; i++) {
      pages.push(i + 1);
    }

    return pages;
  }, [pageLength]);

  
  const onNextCTA = () => {
    if (currentPageNumber == pageLength) {
      return "javascript:void(0)";
    } else {
      return !slug
        ? appendParams("/blog/page-" + (currentPageNumber + 1))
        : appendParams(`/blog/category/${slug}/page-` + (currentPageNumber + 1));
    }
  };

  const handleGa = (ctaText:string) => { 
    pushToDataLayer({
      event: "blogs_navigation",
      cta_text: ctaText,
      section_name: "Explore all blogs",
      page_type: getGlobalStateValue('pageType'),
    });
  }

  const onPreviousCTA = () => {
    if(currentPageNumber == 2){
      return  !slug ? appendParams('/blog') :  appendParams('/blog/category/' + slug);
    } else if (currentPageNumber === 1) {
      return "javascript:void(0)";
    } else {
      return !slug
        ? appendParams("/blog/page-" + (currentPageNumber - 1))
        : appendParams(`/blog/category/${slug}/page-` + (currentPageNumber - 1));
    }
  };

  const renderPages = pageNumbers.slice(pageBufferSize, pageBufferSize + 5).map((item) => (
    <button
      key={item}
      className={item === currentPageNumber ? styles.btnContainerSelected : styles.btnContainer}
    >
      <Link
        onClick={()=>handleGa(item)}
        href={
          item == 1 ? appendParams(`/blog${slug ?  '/category/'+slug : ""}`) : appendParams(`/blog${slug ? '/category/'+slug : ""}/page-` + item)
        }
      >
        {item}
      </Link>
    </button>
  ));

  if (pageLength === 1) return null;

  return (
    <div className={styles.container}>
      {isButtonVisible && (
        <button className={styles.btnContainer}>
          <Link onClick={()=>{
            handleGa("left");
          }} href={onPreviousCTA()}>{"<"}</Link>
        </button>
      )}
      {renderPages}
      {isButtonVisible && (
        <button className={styles.btnContainer}>
          <Link 
          onClick={()=>{
            handleGa("right");
          }}
          href={onNextCTA()}>
            {">"}
          </Link>
        </button>
      )}
    </div>
  );
};

export { PaginationSection };
